<template>
  <div>
    <b-card no-body>
      <b-tabs pills card>
        <b-tab :title="$t('Main')">
          <b-form-group label-align="right" :label="$t('Parent service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffs || isTariffPlan">
            <b-form-input type="text" disabled v-model="vodService.service_data.parent_id"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="serviceName" aria-describedby="inputFeedbackName" :state="validationName"/>
            <b-form-invalid-feedback id="inputFeedbackName">
              {{ $t('Enter title') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="vodService.service_data.comment"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Supplier to invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="suppliertList" v-model="selectSupplier"/>
          </b-form-group>
          <b-form-group v-if="isTemplates || isTariffs || isTariffPlan">
            <b-form-checkbox v-model="linkByDefault">{{ $t('Attach by default') }}</b-form-checkbox>
            <b-form-checkbox v-model="multipleLinking">{{ $t('Allow multiple linking') }}</b-form-checkbox>
          </b-form-group>
        </b-tab>
        <b-tab :title="$t('Service parameters')">
          <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="serviseCost" aria-describedby="inputFeedbackCost" :state="validationCost"/>
            <b-form-invalid-feedback id="inputFeedbackCost">
              {{ $t('Enter cost') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Duration')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="vodService.vod_service_data.duration"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Contract type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="contractList" v-model="selectContract">
              <template slot="first">
                <option :value=0></option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('IPTV system type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-select :options="typeVodList" v-model="selectVod"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Custom options')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="selectVod !== 1 && selectVod !== 0">
            <b-form-input type="text" v-model="vodService.vod_service_data.custom_data"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Media content')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="selectVod === 0">
            <b-row>
              <b-col cols="10">
                <b-form-select :options="mediaContentList" v-model="selectMediaContent"/>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Service ID')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="selectVod === 1">
            <b-form-input type="nymber" v-model="serviceId"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Movie ID')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="selectVod === 1">
            <b-form-input type="nymber" v-model="movieId"/>
          </b-form-group>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-row>
      <b-col>
        <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveVodService">Ok</b-button>
      </b-col>
      <b-col sm="1.5">
        <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideModalServices">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'

export default {
  props: {
    isTariffs: null,
    isTemplates: null,
    isEdit: null,
    isTariffPlan: null,
    currentRowService: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      serviceId: 0,
      movieId: 0,
      linkByDefault: true,
      multipleLinking: false,
      serviceName: '',
      serviseCost: 0,
      validationName: false,
      validationCost: true,
      selectSupplier: 0,
      suppliertList: [],
      selectContract: 0,
      contractList: [],
      selectVod: 0,
      typeVodList: [
        {text: 'NetUP', value: 0},
        {text: 'Megogo', value: 1},
        {text: this.$i18n.t('Other'), value: 2}
      ],
      selectNetup: 1,
      typeNetupList: [
        {text: this.$i18n.t('TV-channels'), value: 1},
        {text: this.$i18n.t('Radio'), value: 2}
      ],
      selectMediaContent: 0,
      mediaContentList: [],
      editVodServices: null,
      vodService: {
        'vod_service_data': {
          'media_content': 0,
          'media_group': 0,
          'custom_data': '',
          'duration': 0,
          'vod_type': 0
        },
        'periodic_service_data': {
          'charge_method': 0,
          'cost': 1
        },
        'service_data': {
          'comment': '',
          'contract_type': 0,
          'invoice_sup_id': 0,
          'is_dynamic': 0,
          'link_by_default': 0,
          'multiple_linking': 0,
          'parent_id': 0,
          'service_name': '',
          'tariff_id': 0
        }
      }
    }
  },
  methods: {
    async saveVodService () {
      if (!this.serviceName || !(this.serviseCost >= 0)) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name or cost fields is invalid'), 'Error')
        return
      }
      if (this.selectVod === 0) {
        this.vodService.vod_service_data.media_content = this.selectMediaContent
      }
      let response
      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        if (this.vodService.service_data.parent_id === 0) this.vodService.service_data.parent_id = -1
        this.linkByDefault ? this.vodService.service_data.link_by_default = 1 : this.vodService.service_data.link_by_default = 0
      }
      if (this.isTariffPlan) {
        this.vodService.service_data.tariff_id = this.currentRowTariffPlans.id
      }
      if (this.isEdit) {
        this.vodService.service_data.tariff_id = this.editVodServices.service_data.tariff_id
      }
      if (this.selectVod === 1) {
        this.vodService.vod_service_data.custom_data = 'ServiceId:' + this.serviceId + ',delay:0,additional:fasle,movieId:' + this.movieId
      }
      this.vodService.service_data.service_name = this.serviceName
      this.vodService.periodic_service_data.cost = Number(this.serviseCost)
      this.vodService.service_data.contract_type = this.selectContract
      this.vodService.vod_service_data.vod_type = this.selectVod
      this.vodService.vod_service_data.duration = Number(this.vodService.vod_service_data.duration) * 3600
      if (this.isEdit) {
        this.vodService.service_data.service_id = this.editVodServices.service_data.service_id
        axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_VOD, this.vodService).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideModalServices')
            this.$emit('reload')
            setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          }
        })
      } else {
        response = await axiosInstance.post(this.$store.getters.API_TARIFFING_SERVICES_VOD, this.vodService).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideModalServices')
            this.$emit('reload')
            setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
            return response.data.service_id
          }
        })
      }
      let suppId = {
        'service_id': 0,
        'invoice_sup_id': 0
      }
      if (this.isEdit) {
        suppId.service_id = this.editVodServices.service_data.service_id
      } else {
        suppId.service_id = response
      }
      suppId.invoice_sup_id = this.selectSupplier
      axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_SET_SUPPLIER_ID, suppId)
      if ((this.isTemplates && this.multipleLinking) || (this.isTariffPlan && this.multipleLinking)) {
        let multiLink = {
          'service_id': 0,
          'multiple_linking': 0
        }
        if (this.isEdit) {
          multiLink.service_id = this.editVodServices.service_data.service_id
        } else {
          multiLink.service_id = response
        }
        multiLink.multiple_linking = 1
        axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_SET_MULTI_LINKING, multiLink)
      }
    },
    async load () {
      let contractList = await axiosInstance.get(this.$store.getters.API_TARIFFING_CONTRACT_TYPES).then(response => { return response.data })
      let suppliertList = await axiosInstance.get(this.$store.getters.API_TARIFFING_SUPPLIER).then(response => { return response.data })
      for (let i in suppliertList) {
        suppliertList[i].value = suppliertList[i].id
        suppliertList[i].text = suppliertList[i].name
      }
      this.suppliertList = suppliertList
      for (let i in contractList) {
        contractList[i].value = contractList[i].id
        contractList[i].text = contractList[i].name
      }
      this.contractList = contractList
      if (this.isEdit || this.isTariffPlan) {
        this.editVodServices = await axiosInstance.get(this.$store.getters.API_TARIFFING_SERVICES_VOD + '?service_id=' + this.currentRowService.service_id).then(response => { return response.data })
        this.serviceName = this.editVodServices.service_data.service_name
        this.serviseCost = this.editVodServices.periodic_service_data.cost
        this.vodService.service_data.comment = this.editVodServices.service_data.comment
        this.selectSupplier = this.editVodServices.service_data.invoice_sup_id
        this.selectContract = this.editVodServices.service_data.contract_type
        this.selectVod = this.editVodServices.vod_service_data.type
        this.vodService.vod_service_data.duration = this.editVodServices.vod_service_data.duration / 3600
        this.vodService.vod_service_data.custom_data = this.editVodServices.vod_service_data.custom_data
      }
      if (this.selectVod === 1) {
        let str = JSON.parse(JSON.stringify(this.editVodServices.vod_service_data.custom_data.split(',')))
        this.serviceId = str[0].split(':')[1]
        this.movieId = str[3].split(':')[1]
      } else {
        this.vodService.vod_service_data.custom_data = this.editVodServices.vod_service_data.custom_data
      }
      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        this.vodService.service_data.parent_id = this.editVodServices.service_data.parent_id
        if (this.editVodServices.service_data.link_by_default === 1) {
          this.linkByDefault = true
        } else {
          this.linkByDefault = false
        }
        if (this.editVodServices.service_data.multiple_linking === 1) {
          this.multipleLinking = true
        } else {
          this.multipleLinking = false
        }
      }
    },
    hideModalServices () {
      this.$emit('hideModalServices')
    },
    async loadMedia () {
      let mediaContentList = await axiosInstance.get(this.$store.getters.API_TARIFFING_MEDIA_CONTENTS).then(response => { return response.data })
      let filtredMediaContent = []
      for (let i in mediaContentList) {
        if (mediaContentList[i].type !== 'vod') {
          continue
        }
        mediaContentList[i].value = mediaContentList[i].id
        mediaContentList[i].text = mediaContentList[i].name
        filtredMediaContent.push(mediaContentList[i])
      }
      this.mediaContentList = filtredMediaContent
      if (this.mediaContentList.length > 0) {
        this.selectMediaContent = this.mediaContentList[0].id
      }
    }
  },
  mounted () {
    this.load()
    this.loadMedia()
  },
  watch: {
    serviceName: function (val) {
      if (val.length) {
        this.validationName = true
      } else {
        this.validationName = false
      }
    },
    serviseCost: function (val) {
      if (val >= 0) {
        this.validationCost = true
      } else {
        this.validationCost = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formVodService.vue